"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const http_error_1 = __importDefault(require("./http-error"));
class SentinelError extends Error {
    constructor(message, name, data, statusCode) {
        super(message);
        this.name = name;
        this.statusCode = statusCode !== null && statusCode !== void 0 ? statusCode : null;
        this.data = data !== null && data !== void 0 ? data : {};
    }
    static isParseable(payload) {
        const isObject = typeof payload === 'object' && !Array.isArray(payload) && payload !== null;
        if (!isObject)
            return false;
        const record = payload;
        if (typeof record.name !== 'string' || typeof record.message !== 'string')
            return false;
        const isDataValid = record.data === undefined ||
            (typeof record.data === 'object' && !Array.isArray(record.data) && record.data !== null);
        if (!isDataValid)
            return false;
        return true;
    }
    static parse(payload, statusCode) {
        if (SentinelError.isParseable(payload)) {
            return new SentinelError(payload.message, payload.name, payload.data, statusCode);
        }
        if (statusCode) {
            return new http_error_1.default(payload, statusCode);
        }
        return null;
    }
}
exports.default = SentinelError;
//# sourceMappingURL=sentinel-error.js.map